// extracted by mini-css-extract-plugin
export var brand = "_bs-9";
export var compact = "_bs-6";
export var extraSmall = "_bs-7";
export var icon = "_bs-0";
export var large = "_bs-4";
export var light = "_bs-1";
export var medium = "_bs-5";
export var outline = "_bs-b";
export var primaryDark = "_bs-a";
export var primaryLight = "_bs-8";
export var primaryModern = "_bs-c";
export var success = "_bs-2";
export var successSolid = "_bs-3";